export class BreadCrumbItem
{
  public title:string;
  public sessionID:string;
  public viewTypeID: string;
}